import { z } from 'zod';

export const economicEventSchema = z.object({
  id: z.string(),
  date: z.string(), // ISO 8601 date string
  country: z.string(),
  name: z.string(),
  period: z.string(),
  category: z.string(),
  period_year: z.number(),
  actual: z.number().nullish(),
  actual_unit: z.string().nullish(),
  consensus: z.number().nullish(),
  consensus_unit: z.string().nullish(),
  description: z.string().optional(),
  prior: z.number().nullish(),
  prior_unit: z.string().nullish(),
  surprise: z.number().nullish(),
  surprise_unit: z.string().nullish(),
});

export type EconomicEvent = z.infer<typeof economicEventSchema>;

export const economicsResponseSchema = z.object({
  economics: z.array(economicEventSchema),
});
export type EconomicsResponse = z.infer<typeof economicsResponseSchema>;
